import type { LocationQuery } from 'vue-router'
import { firstValue } from 'refresh-common'

/** interact-v1 query names, still on SMS/print links that now redirect here, and what they became. */
const LEGACY_NAMES: Record<string, string> = {
  kod: 'campaignCode',
  summa: 'sum',
  personnummer: 'ssn',
  telefon: 'mobile',
  epost: 'email',
  lamnatut: 'handedOut',
}

/**
 * The query with every legacy name renamed, or null when there is none to rename.
 * A non-empty value already under the new name wins.
 */
export function renameLegacyQuery(query: LocationQuery): LocationQuery | null {
  const isLegacy = (key: string) => Object.hasOwn(LEGACY_NAMES, key)
  if (!Object.keys(query).some(isLegacy)) return null

  const renamed: LocationQuery = {}
  for (const [key, value] of Object.entries(query)) {
    if (!isLegacy(key)) renamed[key] = value
  }
  for (const [legacy, name] of Object.entries(LEGACY_NAMES)) {
    const value = firstValue(query[legacy])
    if (typeof value !== 'string' || !value || firstValue(renamed[name])) continue
    renamed[name] = value
  }
  return renamed
}
